import { PayoutFrequency } from 'generated/graphql';
import { payoutFrequencyList } from '../../../utils/helpers/lists/PayoutFrequencyList';

export const getPayoutFrequencyRu = (payoutFrequency?: PayoutFrequency | null) => {
  const res = payoutFrequencyList.find(el => el.id === payoutFrequency)?.name;
  if (!res) return '';
  return res;
};
